// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)
import VueResource from 'vue-resource'
Vue.use(VueResource)

// import router from './router'
// 为了方便看，我把router的配置直接放到这个入口文件中，以后再分离出来

import VueRouter from 'vue-router'
// import firstHtml from './components/decorator/header.vue'
Vue.use(VueRouter)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
})


$(function(){
	jQuery(".footer_copy").html((new Date()).getFullYear());
	var myLinks = $(".contact-us").find("li");
			if(/AppleWebKit.*Mobile/i.test(navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent))){ 
			    if(window.location.href.indexOf("?mobile")<0){ 
			        try{ 
			            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){ 
			                for(var i = 0; i < myLinks.length; i++){
							　　	myLinks[i].addEventListener("click", function(){							
									$(this).find(".Panel").toggle();	
									$(this).siblings().find(".Panel").hide();
								}, false);
							　　
							}
			            }else if(/iPad/i.test(navigator.userAgent)){ 
			            }else{ 
			            } 
			        }catch(e){} 
			    } 
			}
})



// WEBPACK FOOTER //
// ./src/main.js